import React from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import {observer} from "mobx-react";
import {DrawerBodyBox} from "./boxes/body/drawer-body.box";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {IDrawer} from "../../services/drawer/drawer.service.interface";
import {DrawerContentBox} from './boxes/content/drawer-content.box';


export interface DrawerComponentProps{
  drawer: IDrawer
  className?: string;
}

@observer
export class DrawerComponent extends OrbitComponent<DrawerComponentProps> {

  private _renderDrawer() {
    let zIndex = this.props.drawer.getOverlayZIndex();
    let lastVisibleDrawerItemIndex = this.props.drawer.getLastVisibleDrawerItemIndex();

    return (

      <DrawerBodyBox zIndex={zIndex} className={classNames(this.props.className, {
        open: this.props.drawer.isOpen
      })}>
        {this.props.drawer.currentContent.map((content, index) => {
          return (
              <DrawerContentBox key={content.id} id={content.id} visible={index === lastVisibleDrawerItemIndex}>
                {content.render()}
              </DrawerContentBox>
          )
        })}
      </DrawerBodyBox>
    );
  }

  render() {
    return ReactDOM.createPortal(this._renderDrawer(), this.services.dom.body);
  }
}
